module.exports = __webpack_public_path__ + "static/media/four.7934c2f9.svg";